import Uploader from "../components/common/Uploader";
import '@smastrom/react-rating/style.css'
import AddressSearch from "../components/AddressSearch";
import QuoteSettingsAmenities from "./QuoteSettingsAmenities";
import QuoteSettingsInfo from "./QuoteSettingsInfo";
import {useMutation} from "react-query";
import {AccommodationImage, AccomodationInfo} from "../types";
import {deleteAccommodationImage, saveAccomodationInformation, storeAccommodationImage} from "../shared/queries";
import toast from "react-hot-toast";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {fetchAccommodationImages} from "../store/slices/accommodationSettingsSlice";
import {useAppDispatch, useAppSelector} from "../hooks/redux";
import Spinner from "../components/Spinner";
import {useTranslation} from "react-i18next";

export default function PremiumPage () {

    const { t } = useTranslation()

    const dispatch = useAppDispatch()
    const currentHotelObject = useSelector<any>(state => state.hotels.currentHotelObject) as any

    const { accommodationImages, info } = useAppSelector(state => state.accommodationSettingsSlice)

    const [deleteImage, setDeleteImage] = useState<boolean>(false)

    useEffect(() => {
        if (!currentHotelObject || !currentHotelObject.idAccomodation) return
        dispatch(fetchAccommodationImages(currentHotelObject.idAccomodation))
    }, [
        currentHotelObject
    ])

    const updateAccommodationGalleryMutation = useMutation((image: AccommodationImage) => storeAccommodationImage({
        ...image,
        idAccomodation: currentHotelObject.idAccomodation
    }), {
        onSuccess: () => {
            toast.success('Gallery salvata')
            dispatch(fetchAccommodationImages(currentHotelObject.idAccomodation))
        }
    })

    function handleUploadImage (data: any) {
        console.log(data, 'uploaded')
        updateAccommodationGalleryMutation.mutate({
            imageUrl: data.data.uploadURL
        })
    }

    const saveAddressMutation = useMutation(({ accommodationInfo, address, zipCode, idCountry, city, lat, lng }: { accommodationInfo: AccomodationInfo, address: string, zipCode: string, idCountry: number, city: string, lat: number, lng: number }) => saveAccomodationInformation({
        ...accommodationInfo,
        address: address,
        zipCode: zipCode,
        idCountry: idCountry,
        city: city,
        lat,
        lng
    }))

    async function handleDeleteImage (data: AccommodationImage) {
        try {
            setDeleteImage(true)
            if (!data || !data.idAccomodationImage) return
            if (window.confirm("Are you sure you want to delete this request?")) {
                await deleteAccommodationImage(data.idAccomodationImage)
                toast.success('Image deleted')
                dispatch(fetchAccommodationImages(currentHotelObject.idAccomodation))
            }
        } catch (error) {
            console.log(error)
        } finally {
            setDeleteImage(false)
        }
    }

    return (
        <div>
            <div className="max-w-6xl mx-auto py-12">

                <div className="flex space-x-12 items-center border-b pb-6 mb-6">
                    <div>
                        <div>
                            <img src="/premium.svg" alt="Premium account" className={'w-56'} />
                        </div>
                    </div>
                    <div>
                        <div className="text-3xl text-slate-700 font-semibold">
                            Programma premium
                        </div>
                        <div className="text-slate-500 text-lg mt-2">
                            inserisci i contenuti della tua struttura per accedere al programma premium
                        </div>
                    </div>
                </div>

                <div>
                    <div className="mb-4 flex space-x-2 items-top">
                        <div className={'text-slate-600 p-0.5'}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div>
                            <div className={'font-bold text-lg text-slate-600'}>
                                La tua galleria fotografica
                            </div>
                            <div className="text-slate-500">
                                da 1 a 3 fotografie che rappresentano al meglio la tua struttura
                            </div>
                        </div>
                    </div>

                    <div className={'mb-4 flex space-x-2    '}>
                        {
                            accommodationImages.map((image, i) => (
                                <div key={i} style={{ backgroundImage: `url(${image.imageUrl})` }} className={'w-32 h-32 rounded-xl bg-cover bg-center overflow-hidden group'}>
                                    <div className={'hidden bg-red-600/50 w-full h-full transition-all justify-center items-center group-hover:flex'}>
                                        <button className={'w-14 h-14 flex items-center justify-center bg-white rounded-full p-2 text-red-600 hover:scale-110 transition-all'} onClick={() => handleDeleteImage(image)}>
                                            {
                                                deleteImage ?
                                                    <Spinner className={'mr-0'} color={'red-700'} />
                                                    :
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                                        <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z" clipRule="evenodd" />
                                                    </svg>
                                            }
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div className="bg-slate-50 border border-slate-200 rounded-md">
                        <Uploader
                            fileType={'image'}
                            type={'dashboard'}
                            folderKey={'accomodation-gallery'}
                            fileKey={'image'}
                            onUpload={(data: any) => handleUploadImage(data)}
                        />
                    </div>
                </div>

                <div className={'mt-8 border-t pt-8'}>
                    <div className="mb-4 flex space-x-2 items-top">
                        <div className={'text-slate-600 p-0.5'}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div>
                            <div className={'font-bold text-lg text-slate-600'}>
                                Le informazioni della tua struttura
                            </div>
                            <div className="text-slate-500">
                                tutti i dettagli che compongono la scheda della tua struttura
                            </div>
                        </div>
                    </div>

                    <form>
                        <div className="space-y-12">
                            <QuoteSettingsInfo save={false} title={false} />

                            <div className="border-t pt-8 border-b border-gray-900/10 pb-12">
                                <div className="mb-4 flex space-x-2 items-top">
                                    <div className={'text-slate-600 p-0.5'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                            <path fillRule="evenodd" d="M8.161 2.58a1.875 1.875 0 0 1 1.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0 1 21.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 0 1-1.676 0l-4.994-2.497a.375.375 0 0 0-.336 0l-3.868 1.935A1.875 1.875 0 0 1 2.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437ZM9 6a.75.75 0 0 1 .75.75V15a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 9 6Zm6.75 3a.75.75 0 0 0-1.5 0v8.25a.75.75 0 0 0 1.5 0V9Z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className={'font-bold text-lg text-slate-600'}>
                                            Posizione della tua struttura
                                        </div>
                                        <div className="text-slate-500">
                                            le informazioni per mostrare la tua struttura sulla nostra mappa
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                    <div className="col-span-full">
                                        <label htmlFor="street-address" className="block text-sm/6 font-medium text-gray-900">
                                            Ricerca indirizzo o nome della tua struttura
                                        </label>
                                        <div className="mt-2">
                                            <AddressSearch onAddressSelected={data => {
                                                if (!info || !info.idAccomodation) return
                                                console.log(data, info, {
                                                    accommodationInfo: info,
                                                    address: data.addressStreet,
                                                    zipCode: data.addressZipCode,
                                                    idCountry: data.idCountry,
                                                    city: data.addressCity
                                                })
                                                saveAddressMutation.mutate({
                                                    accommodationInfo: info,
                                                    address: data.addressStreet,
                                                    zipCode: data.addressZipCode,
                                                    idCountry: data.idCountry,
                                                    city: data.addressCity,
                                                    lat: data.addressLatitude,
                                                    lng: data.addressLongitude
                                                })
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="border-b border-gray-900/10 pb-12">
                                <div className="mb-4 flex space-x-2 items-top">
                                    <div className={'text-slate-600 p-0.5'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                            <path fillRule="evenodd" d="M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className={'font-bold text-lg text-slate-600'}>
                                            I tuoi servizi
                                        </div>
                                        <div className="text-slate-500">
                                            l'elenco dei tuoi servizi della tua struttura
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-10 space-y-10">
                                    <QuoteSettingsAmenities title={false} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

        </div>
    )

}
